import { Col, Container, Row } from "react-bootstrap";

export default function PredictorSettingsHeader({ minWidth = 0 }) {
    return (
        <Container fluid style={{ minWidth }}>
            <Row className="bg-ra-dark-blue text-white fw-bold py-1 rounded-2 fs-8-xs table-header user-select-none align-items-center text-center">
                <Col xs={2}>Lookback Weeks</Col>
                <Col xs={2}>Max Spins</Col>
                <Col xs={2}>Max Song Age Weeks</Col>
                <Col>
                    <Row className="border-bottom">
                        <Col>Release Year</Col>
                    </Row>
                    <Row>
                        <Col xs={6}>From</Col>
                        <Col xs={6}>To</Col>
                    </Row>
                </Col>
                <Col xs="auto" style={{ width: 108 }}></Col>
            </Row>
        </Container>
    );
}
